import { ca } from '@cian/analytics';

import { convertToFavoriteEntityType } from './favoriteEntity';
import { getPageNumber, EOfferType } from './trackings';
import { EDeviceType } from '../types/device';
import { EEntityType } from '../types/filters';
import { IFavoriteEntity } from '../types/results';

interface IPhonesEventParameters {
  entity: IFavoriteEntity;
  position: number;
  total: number;
  deviceType: EDeviceType;
}

export function trackBookButtonClick({ entity, position, total, deviceType }: IPhonesEventParameters) {
  ca('eventEbc', {
    category: 'Phones',
    action: 'Open_favorites',
    label: getCustomUrl(entity),
    name: 'oldevent',
    page: {
      listingType: 'list',
      sortType: 'default',
      pageNumber: getPageNumber(total, position),
      offersQty: total,
      pageType: 'ListingFavorites',
      siteType: deviceType === 'phone' ? 'mobile' : deviceType,
    },
    products: [favoriteEntityToTrackingProduct(entity, position)],
  });
}

function favoriteEntityToTrackingProduct(entity: IFavoriteEntity, position: number) {
  /**
   * Объект products для карточки ЖК
   */
  if (entity.jkInfo) {
    return {
      id: entity.entityId,
      offerType: EOfferType.JK,
      position,
    };
  }

  /**
   * Объект products для карточки объявления
   */
  return {
    id: entity.entityId,
    offerType: EOfferType.Offer,
    position,
    published: entity ? entity.status === 'published' : false,
    extra: {
      isPartner: entity.isCianPartner,
    },
  };
}

export function getCustomUrl(favoriteEntity?: IFavoriteEntity): string | undefined {
  if (favoriteEntity) {
    const { dealType, entityType, entityId } = favoriteEntity;

    return `/${dealType}/${convertToFavoriteEntityType(entityType as unknown as EEntityType)}/${entityId}`;
  } else {
    return undefined;
  }
}
